export default "__VITE_ASSET__ac36aea4__"